import * as React from "react";
import styled, { css } from "styled-components";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "components/common";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import usePluginEntities from "hooks/usePluginEntities";
import useActiveDataLakes from "data-lake/preview/hooks/useActiveDataLakes";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const StyledSelect = styled(Select)`
  min-width: 280px;
`;
const OptionContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
  `
);
const OptionIcon = styled.div`
  display: flex;
  align-items: center;
`;
const Option = ({ label, value }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const dataLakePlugins = usePluginEntities("dataLakeStorageTypes");
  const { data: dataLakes } = useActiveDataLakes();
  const dataLake = dataLakes.find(({ id }) => id === value);
  const dataLakePlugin = dataLakePlugins.find(({ storageType }) => storageType === dataLake.storageType);
  const Icon = dataLakePlugin.icon;
  return /* @__PURE__ */ React.createElement(OptionContainer, null, /* @__PURE__ */ React.createElement(OptionIcon, null, /* @__PURE__ */ React.createElement(Icon, null)), dataLake.type === INTERNAL_DATA_LAKE_TYPE ? t("type_select.internal") : t("type_select.external"), " \u2014 ", label);
};
const DataLakeTypeSelect = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const { data: dataLakes } = useActiveDataLakes();
  const { selectDataLake, selectedDataLake } = useSelectedDataLake();
  const dataLakeOptions = useMemo(() => dataLakes.map(({ id, title }) => ({ label: title, value: id })), [dataLakes]);
  const selectOption = (dataLakeId) => {
    selectDataLake(dataLakeId);
  };
  return /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      id: "dataLakeType",
      name: "dataLakeType",
      placeholder: t("type_select.placeholder"),
      clearable: false,
      valueRenderer: Option,
      optionRenderer: Option,
      options: dataLakeOptions,
      onChange: selectOption,
      value: selectedDataLake.id
    }
  );
};
export default DataLakeTypeSelect;
